/** Local EthSwitch checkout attempt markers (per application + bill). */
export function ethSwitchAttemptKey(applicationId: number, billRef?: string): string {
  const appPart = String(applicationId);
  if (billRef) {
    return `ethSwitchAttempt:${appPart}:${billRef}`;
  }
  return `ethSwitchAttempt:${appPart}`;
}

export function markEthSwitchAttemptIncomplete(applicationId: number, billRef: string): void {
  if (!applicationId || !billRef) {
    return;
  }
  localStorage.setItem(ethSwitchAttemptKey(applicationId, billRef), '1');
  localStorage.removeItem(ethSwitchAttemptKey(applicationId));
}

export function clearEthSwitchAttemptMarker(applicationId: number, billRef?: string): void {
  if (!applicationId) {
    return;
  }
  if (billRef) {
    localStorage.removeItem(ethSwitchAttemptKey(applicationId, billRef));
    localStorage.removeItem(ethSwitchAttemptKey(applicationId));
    return;
  }
  const prefix = `${ethSwitchAttemptKey(applicationId)}:`;
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) {
      localStorage.removeItem(key);
    }
  }
  localStorage.removeItem(ethSwitchAttemptKey(applicationId));
}

export function hasEthSwitchIncompleteAttempt(applicationId: number, billRef: string): boolean {
  if (!applicationId || !billRef) {
    return false;
  }
  return localStorage.getItem(ethSwitchAttemptKey(applicationId, billRef)) === '1';
}

/** Open payment checkout in a new tab (Telebirr / EthSwitch HPP). */
export function openPaymentCheckoutUrl(url: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
